import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchSelector } from 'common/state/common';
import { API_URLS } from 'settings/api';
import { RawRestriction, Restrictions } from 'common/types/filters';
import { useRecoilValue } from 'recoil';
import { useRollbar } from '@rollbar/react';
import { processError } from 'utils/helpers';

export const useGetAllRestrictions = (): UseQueryResult<Restrictions[], unknown> => {
  const rollbar = useRollbar();
  const { fetchGet } = useRecoilValue(fetchSelector);
  return useQuery(
    ['restrictions'],
    async () => {
      try {
        const rawRestrictions = await fetchGet<RawRestriction[]>(API_URLS.RESTRICTIONS);
        return rawRestrictions;
      } catch (e) {
        const boundRollbarError = rollbar.error.bind(rollbar);
        processError(e, boundRollbarError, 'useGetAllRestrictions error');
      }
    },
    {
      staleTime: Infinity,
      placeholderData: [],
    },
  );
};
